import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "inline" }

import { required } from '@vuelidate/validators';
import {
	UiForm,
	UiAudio,
	UiButton,
	useForm
} from '@/ui-kit';
import PhoneDetailsPanel from './PhoneDetailsPanel.vue';
import { usePhoneNumberDetails } from '../composition';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PhoneNumberVoicemail',
  props: {
    disabled: { type: Boolean }
  },
  emits: ["loading"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'loading', value: boolean): void;
}), expose: any, slots: any, attrs: any }) {





const {
	forwardingActive,
	phoneNumberDetails,
	updateVoiceMail
} = usePhoneNumberDetails();
const {
	fillFormData,
	isFormChanged,
	onSubmit,
	loading,
	formData
} = useForm(
	{ allBusyVoiceMessage: null },
	{ allBusyVoiceMessage: { required } }
);

const isDisabled = computed(() => {
	return !isFormChanged({
		allBusyVoiceMessage:
			phoneNumberDetails.value!.allBusyVoiceMessage
	});
});

const fillForm = () => {
	fillFormData(phoneNumberDetails.value);
};

const submit = onSubmit(async (data) => {
	emit('loading', true);
	await updateVoiceMail(data).finally(() => {
		emit('loading', false);
	});
	fillForm();
});

fillForm();

return (_ctx: any,_cache: any) => {
  const _component_ElTooltip = _resolveComponent("ElTooltip")!

  return (_openBlock(), _createBlock(PhoneDetailsPanel, {
    title: "Voicemail",
    subTitle: "Your voicemail greeting will be played when you miss a call.",
    class: _normalizeClass({
			'opacity-50 cursor-not-allowed':
				_unref(forwardingActive)
		}),
    noCollapse: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(UiForm), { onSubmit: _unref(submit) }, {
        default: _withCtx(() => [
          _createVNode(_unref(UiAudio), {
            name: "allBusyVoiceMessage",
            disabled: _unref(forwardingActive) || __props.disabled,
            noRemove: "",
            modelValue: _unref(formData).allBusyVoiceMessage,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formData).allBusyVoiceMessage) = $event))
          }, null, 8, ["disabled", "modelValue"]),
          _createVNode(_component_ElTooltip, {
            disabled: 
					(!_unref(isDisabled) && !_unref(forwardingActive)) ||
					__props.disabled
				,
            "show-after": 500,
            "hide-after": 0,
            enterable: false,
            placement: "left",
            content: "You have no changes to save"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_unref(UiButton), {
                  class: "!h-10 !min-w-24",
                  disabled: 
							_unref(isDisabled) ||
							_unref(forwardingActive) ||
							__props.disabled
						,
                  loading: _unref(loading)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Save Changes")
                  ]),
                  _: 1
                }, 8, ["disabled", "loading"])
              ])
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _: 1
      }, 8, ["onSubmit"])
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})